import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  //nenek time keeper
  //TODO tambah elsa, takut
  {
    x: 2750,
    y: 950,
    name: 'Ato',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_ato.png',
    flipSprite : false,
    dialogTree: {
      startDialogId: 'ato_1',
      nodes: {
        ato_1: {
          id: 'holga_1',
          speaker: 'Ato',
          text: `Holga, kita harus segera bertindak`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "ato_2",
        },
        ato_2: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Saya setuju. Kita butuh bantuan mu Ato.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "ato_3",
        },
        ato_3: {
          id: 'holga_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Apa yang kalian sedang lakukan?',
              nextDialogId: 'ato_4',
            },
            {
              text: 'Tindakan apa yang kalian rencanakan? ',
              nextDialogId: 'ato_4',
            },
          ],
        },
        ato_4: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Tidak sopan menguping pembicaraan orang lain.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2700,
    y: 950,
    name: 'Holga',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_holga.png',
    flipSprite : true,
    stopInteraction : true,
    dialogTree: {
      startDialogId: 'ato_1',
      nodes: {
        ato_1: {
          id: 'holga_1',
          speaker: 'Ato',
          text: `Holga, kita harus segera bertindak`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "ato_2",
        },
        ato_2: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Saya setuju. Kita butuh bantuan mu Ato.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "ato_3",
        },
        ato_3: {
          id: 'holga_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Apa yang kalian sedang lakukan?',
              nextDialogId: 'ato_4',
            },
            {
              text: 'Tindakan apa yang kalian rencanakan? ',
              nextDialogId: 'ato_4',
            },
          ],
        },
        ato_4: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Tidak sopan menguping pembicaraan orang lain.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2250,
    y: 700,
    name: 'Bunga',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_bunga.png',
    flipSprite : true,
    dialogTree: {
      startDialogId: 'bunga_1',
      nodes: {
        bunga_1: {
          id: 'bunga_1',
          speaker: 'Bunga',
          text: `Perasaanku tidak baik Yan...`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "bunga_2",
        },
        bunga_2: {
          id: 'bunga_2',
          speaker: 'Bunga',
          text: `Desa ini tidak aman. Sebaiknya kamu dan elsa cepat pulang`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "bunga_3",
        },
        bunga_3: {
          id: 'bunga_2',
          speaker: 'Bunga',
          text: `Suasana desa sudah tidak kondusif`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "bunga_4",
        },
        bunga_4: {
          id: 'bunga_2',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices : [
            {
              text: 'Aku tidak akan pergi sekarang, misteri Diana belum terpecahkan.',
              nextDialogId: 'bunga_a3',
            },
            {
              text: 'Tempat ini juga berbahaya bagimu Bunga',
              nextDialogId: 'bunga_a1',
              storyAction: { type: 'addCustomValue', value: {key : "bunga_affinity", value : 1} },
            },
          ],
        },
        bunga_a1: {
          id: 'bunga_2',
          speaker: 'Yan',
          text: `Tempat ini juga berbahaya bagimu. Songko selalu mengincar gadis perawan.`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "bunga_a2",
        },
        bunga_a2: {
          id: 'bunga_2',
          speaker: 'Yan',
          text: `Aku tidak akan meninggalkanmu.`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "bunga_a3",
        },
        bunga_a3: {
          id: 'bunga_2',
          speaker: 'Bunga',
          text: 'Apa pun yang kamu ingin lakukan selanjutnya, kita semua harus berhati-hati',
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 1900,
    y: 1520,
    name: 'Nenek',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_nenek2.png',
    flipSprite : true,
    dialogTree: {
      startDialogId: 'nenek_1',
      nodes: {
        nenek_1: {
          id: 'nenek_1',
          speaker: 'Nenek',
          text: `Selamat datang kembali Yan`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_2",
        },
        nenek_2: {
          id: 'nenek_1',
          speaker: 'Nenek',
          text: `Ayo masuk, sudah saatnya beristirahat.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_2a",
        },
        nenek_2a: {
          id: 'nenek_1',
          speaker: '',
          text: `...`,
          backgroundImage: '/assets/backdrop/black.png',
          nextDialogId : "nenek_3",
          //TODO animasi swipe
        },
        nenek_3: {
          id: 'nenek_1',
          speaker: 'Nenek',
          text: `Besok pagi sekali, kamu dan temanmu harus kembali ke kota`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_4",
        },
        nenek_4: {
          id: 'nenek_1',
          speaker: 'Nenek',
          text: `Sudah sangat berbahaya kota ini untuk kalian berdua.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_5",
        },
        nenek_5: {
          id: 'nenek_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "bunga_a3",
          choices : [
            {
              text: 'Aku masih belum mau pulang, masih ada urusan yang belum selesai.',
              nextDialogId: 'nenek_a1',
            },
            {
              text: 'Aku tidak mau meninggalkan nenek dan Bunga',
              nextDialogId: 'nenek_a1',
              storyAction: { type: 'addCustomValue', value: {key : "bunga_affinity", value : 1} },
            },
          ]
        },
        nenek_a1: {
          id: 'nenek_1',
          speaker: 'Bunga',
          text: `Dengarkan nenekmu Yan, tempat ini terlalu berbahaya`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_a2",
        },
        nenek_a2: {
          id: 'nenek_1',
          speaker: 'Bunga',
          text: `Sepertinya sekarang Ato dan orang desa lain sudah berencana untuk mengusir kalian.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_a3",
        },
        nenek_a3: {
          id: 'nenek_1',
          speaker: 'Elsa',
          text: `Yan, aku juga mau pulang`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_a4",
        },
        nenek_a4: {
          id: 'nenek_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          choices : [
            {
              text: 'Baiklah jika itu yang kalian semua mau',
              nextDialogId: 'nenek_a5',
            },
            {
              text: 'Baiklah, jika Elsa menginginkan itu.',
              nextDialogId: 'nenek_a5',
              storyActions: [
                { type: 'addCustomValue', value: {key : "bunga_elsa_affinity", value : -1} },
                { type: 'addCustomValue', value: {key : "elsa_affinity", value : 1} },
                { type: 'addCustomValue', value: {key : "bunga_affinity", value : -1} },
              ],
            },
          ]
        },
        nenek_a5: {
          id: 'nenek_1',
          speaker: 'Nenek',
          text: `Kalau begitu, cepat tidur, nenek akan membangunkan kalian pukul 4.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_a6",
        },
        nenek_a6: {
          id: 'nenek_1',
          speaker: 'Nenek',
          text: `Nenek istirahat dulu ya.`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_a7",
        },
        nenek_a7: {
          id: 'nenek_1',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_a8",
          sfx : "openDoor"
        },
        nenek_a8: {
          id: 'nenek_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          choices : [
            {
              text: 'Bunga, sebaiknya kamu cepat istirahat',
              nextDialogId: 'nenek_c1',
              //TODO if elsa > bunga
            },
            {
              text: 'Elsa, kita besok harus bangun pagi. Kembalilah ke kamar.',
              nextDialogId: 'nenek_d1',
              //TODO if bunga > elsa
            },
            {
              text: 'Bunga, elsa, sebaik nya kita juga cepat istirahat',
              nextDialogId: 'nenek_e1',
            },
          ]
        },
        nenek_c1: {
          id: 'nenek_1',
          speaker: 'Bunga',
          text: `Aku pulang dulu. Selamat malam.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_c2",
        },
        nenek_c2: {
          id: 'nenek_1',
          speaker: 'Elsa',
          text: `Yan... aku tidak mau tidur di kamar Diana.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_c3",
        },
        nenek_c3: {
          id: 'nenek_1',
          speaker: 'Elsa',
          text: `Malam ini, aku tidur bersamamu ya.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_c4",
        },
        nenek_c4: {
          id: 'nenek_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/cutscene/black.png',
          nextDialogId : "nenek_c5",
          sfx  :"openDoor"
        },
        nenek_c5: {
          id: 'nenek_1',
          speaker: 'Elsa',
          text: `[??? WITH ELSA ???] `,//TODO DRAW elsa x yan????
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/kamar_yan.png',
          storyAction: { type: 'nextDay', value: 0 },
        },
        nenek_d1: {
          id: 'nenek_1',
          speaker: 'Elsa',
          text: `Baiklah Yan, selamat malam.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_d2",
        },
        nenek_d2: {
          id: 'nenek_1',
          speaker: 'Elsa',
          text: `Selamat malam`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_d3",
        },
        nenek_d3: {
          id: 'nenek_1',
          speaker: 'Bunga',
          text: `Yan, sebelum kamu tidur`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_d4",
        },
        nenek_d4: {
          id: 'nenek_1',
          speaker: 'Bunga',
          text: `Aku sangat takut. Apakah.....`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_d5",
        },
        nenek_d5: {
          id: 'nenek_1',
          speaker: 'Bunga',
          text: `Aku bisa tidur bersama mu?`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          choices : [
            {
              text: 'Tentu saja, lebih aman bersama',
              nextDialogId: 'nenek_d6',
            },
            {
              text: 'Walaupun ranjang ku hanya untuk satu orang? Tidak apa-apa?',
              nextDialogId: 'nenek_d5a',
            },
          ]
        },
        nenek_d5a: {
          id: 'nenek_1',
          speaker: 'Bunga',
          text: '... Ayo',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_d6",
        },
        nenek_d6: {
          id: 'nenek_1',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutsscene/black.png',
          nextDialogId : "nenek_d7",
        },
        nenek_d7: {
          id: 'nenek_1',
          speaker: 'Bunga',
          text: `Terima kasih Yan. Aku merasa aman disini.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/kamar_yan.png',
          nextDialogId : "nenek_d8",
        },
        nenek_d8: {
          id: 'nenek_1',
          speaker: 'Bunga',
          text: `[??? WITH BUNGA ???] `,//TODO DRAW bunga x yan????
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/kamar_yan.png',
          storyAction: { type: 'nextDay', value: 0 },
        },
        nenek_e1: {
          id: 'nenek_1',
          speaker: 'Bunga',
          text: `Aku pulang dulu ya, selamat malam Yan.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_e2",
        },
        nenek_e2: {
          id: 'nenek_1',
          speaker: 'Elsa',
          text: `Selamat malam Yan.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/ruang_tamu.png',
          nextDialogId : "nenek_e3",
        },
        nenek_e3: {
          id: 'nenek_1',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/black.png',
          storyAction: { type: 'nextDay', value: 0 },
          sfx : "openDoor"
        },
        nenek_e5: {
          id: 'nenek_1',
          speaker: 'Yan',
          text: `Saatnya tidur.`,
          backgroundImage: '/assets/backdrop/kamar_yan.png',
          nextDialogId : "bunga_a3",
          storyAction: { type: 'nextDay', value: 0 },
        },
      },
    },
  },
  {
    x: 2380,
    y: 650,
    name: 'Darius',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_darius.png',
    flipSprite : false,
    dialogTree: {
      startDialogId: 'darius_1',
      nodes: {
        darius_1: {
          id: 'darius_1',
          speaker: 'Darius',
          text: `Yang terjadi ke adikmu adalah cobaan.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "darius_2",
        },
        darius_2: {
          id: 'darius_1',
          speaker: 'Darius',
          text: `Semoga kamu bisa menemukan kekuatan dalam dirimu untuk melewati masa sulit ini.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "darius_3",
        },
        darius_3: {
          id: 'darius_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Yang bisa membuat ku melewati ini adalah membalas dendam',
              nextDialogId: 'darius_4',
              storyActions : [
                { type: 'addCustomValue', value: {key : "general_karma", value : -1} },
              ],
            },
            {
              text: 'Aku hanya ingin mengetahui kebenaran',
              nextDialogId: 'darius_4',
              storyActions : [
                { type: 'addCustomValue', value: {key : "general_karma", value : 1} },
              ],
            },
          ],
        },
        darius_4: {
          id: 'darius_1',
          speaker: 'Darius',
          text: `Semoga kamu dan nenekmu bisa menemukan kedamaian.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "darius_5",
          isEnd : true,
        },
      }
    },
  },
  {
    x: 2300,
    y: 1150,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png',
    flipSprite : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan, aku sudah tidak ingin ada disini lagi. Aku mau pulang.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Kita akan pulang hanya setelah dendam Diana terbalas.',
              nextDialogId: 'bapak_day2_a1',
              storyActions: [
                { type: 'addCustomValue', value: {key : "elsa_affinity", value : -1} },
                { type: 'addCustomValue', value: {key : "general_karma", value : -1} },
              ]
            },
            {
              text: 'Aku mengerti Elsa, tetapi kita harus mendapatkan kebenaran',
              nextDialogId: 'bapak_day2_b1',
              storyActions: [
                { type: 'addCustomValue', value: {key : "elsa_affinity", value : -1} },
              ]
            },
            {
              text: 'Aku mengerti Elsa, berikan aku waktu untuk mempertimbangkan',
              nextDialogId: 'bapak_day2_a1',
            },
          ],
        },
        //TODO selesein ini ada elsa makasih ada elsa uh gak makasih
        elsa_3: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan, aku sudah tidak ingin ada disini lagi. Aku mau pulang.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "elsa_2",
        },
      },
    },
  },
];

export default config;
